// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__pUuOT","form":"Login_form__nfOxq","title":"Login_title__3Ek8f","amprimary":"Login_amprimary__qfzQS"};